export const WelcomeOtherService = () => {
  window.location.href = "Welcome/otherservice.html";
  return <></>;
};